import React, { createRef } from "react";
import ReactDOM from "react-dom";
import debounce from "lodash.debounce";
import _ from "lodash";
import cx from "classnames";

/// sub components
import OverlayInputGuide from "component/molecules/overlayInputGuide";
import DCMTagOverlay from "component/molecules/overlayDCMTag";
import ViewportOrientationMarkers from "component/molecules/overlayOrientationMarker";
import { ContextMenu, MenuItem, ContextMenuTrigger } from "react-contextmenu";
import Cache from "core/cache/index";

/// functions
import { getDefaultViewport } from "./ViewportConfig.js";
import renderToCanvas from "core/render/renderToCanvas.js";
import resize from "core/canvas/resize.js";
import { default as mouseWheelInput } from "component/molecules/viewport/interfaces/mouse-wheel-input.js";
//import { stackScrollWheel } from "component/toolManager/stackScroll.js";
import BuiltInTool from "./tools";
import {
  getEnabledElement,
  addEnabledElement,
  hasEnabledElement,
  updateEnabledElement
} from "component/toolManager/enabledElements.js";
import addEnabledElementToolStore from "component/molecules/viewport/toolStates/addEnabledElement.js";
import { addTool } from "component/molecules/viewport/toolStates/addTool.js";

import {
  getToolState,
  clearElementState
} from "component/toolManager/toolState.js";

import math from "core/math";
import { removeToolState } from "component/toolManager/toolState.js";

import getStoredPixels from "core/lookupTable/getStoredPixels.js";
import { default as getRGBPixels } from "core/lookupTable/getRGBPixels.js";
import { gridLayoutInstance } from "component/orgaisms/gridViewportSection/index.js";

/// message dispatcher
import FloatMessageBox from "core/messageBoxController/index";
import pubsub from "core/global/global";
import CustomEvent from "core/customEvent/index";
import {
  MouseEventDispatcher,
  ToolEventDispatcher,
  ImageRenderedEventDispatcher
} from "./core/eventDispatcher";

import getActiveToolsForElement from "component/molecules/viewport/toolStates/getActiveToolsForElement.js";
import getToolsForElement from "component/molecules/viewport/toolStates/getToolsForElement.js";
import { getters } from "component/molecules/viewport/toolStates/store.js";
/// load measurement toool
import LengthTool from "component/molecules/viewport/tools/annotation/LengthTool.js";
import RectangleRoiTool from "component/molecules/viewport/tools/annotation/RectangleRoiTool.js";
import EllipseRoiTool from "component/molecules/viewport/tools/annotation/EllipseRoiTool.js";
import LineTool from "component/molecules/viewport/tools/annotation/LineTool.js";
import AngleTool from "component/molecules/viewport/tools/annotation/AngleTool.js";
import CobbAngleTool from "component/molecules/viewport/tools/annotation/CobbAngleTool.js";
import BrushTool from "component/molecules/viewport/tools/annotation/brushTool/BrushTool";
import brush from "component/molecules/viewport/tools/annotation/brushTool/brushModule.js";
import ReferenceLine from "component/molecules/viewport/tools/annotation/ReferenceLinesTool";

import EraseTool from "component/molecules/viewport/tools/annotation/EraseTool.js"


//import { addTool } from "component/toolManager/";
// State
import {
  setToolActive,
  setToolPassive,
  setToolEnabled
} from "component/molecules/viewport/toolStates/setToolMode.js";

/// Helper
import Helper from "core/helper/index";

// Constants
import Constants from "constants/index";

import "./Viewport.styl";
import Canvas from "core/canvas/index.js";

import { inject } from "mobx-react";
import store from "core/store/";
// import EraseTool from "./tools/annotation/EraseTool.js";

let cursorPageX = 0;
let cursorPageY = 0;

/**
 * @description
 * @function getPixelValue
 * @param x
 * @param y
 * @param z
 */
function getPixelValue(x, y, element, isColor) {
  const enabledElement = getEnabledElement(element);
  const image = enabledElement.image;

  if (!_.get(image, "columns")) {
    return "";
  }

  if (x < 0 || x >= image.columns || y < 0 || y >= image.rows) {
    return "";
  }

  let text = "";
  if (isColor) {
    const storedPixels = getRGBPixels(element, x, y, 1, 1);
    if (storedPixels === null || storedPixels[0] === undefined) {
      return "";
    }
    text = `R: ${storedPixels[0]} G: ${storedPixels[1]} B: ${storedPixels[2]}`;
  } else {
    const storedPixels = getStoredPixels(element, x, y, 1, 1);
    if (storedPixels === null || storedPixels[0] === undefined) {
      return "";
    }
    const value = storedPixels[0];
    const mo = value * image.rescaleSlope + image.rescaleIntercept;
    //text = "Val : " + value;
    text = "Val : " + mo;
  }

  return text;
}
/**
 * Create a canvas or returns the one that already exists for a given element
 *
 * @param {HTMLElement} element An HTML Element
 * @return {HTMLElement} canvas A Canvas DOM element
 */
function getCanvas(element) {
  const selector = `canvas.viewer-canvas`;

  return element.querySelector(selector);
}

function clip(val, low, high) {
  // Clip a value to an upper and lower bound.
  return Math.min(Math.max(low, val), high);
}

// /**
//  * @description LayoutChooser UI Component Properties
//  *
//  * @interface IViewportProps
//  * @extends {HTMLAttributes<HTMLDivElement>}
//  */
// interface IViewportProps extends HTMLAttributes<HTMLDivElement> {
//   /**
//    * @description viewport 식별자
//    * @todo 원래 ID를 쓸려고했는데 Typescript에 적절한 사용방법을 아직모름. 수정 필요
//    */
//   identifier: number;
//   /**
//    * @description viewport Active 상태 여부
//    */
//   isActive: boolean;
//   /**
//    * @description 스크롤 처리 함수
//    * @todo 수정필요
//    */
//   onScroll?: any;
//   /**
//    * @description 스크롤 인덱스
//    */

//   scrollIdx?: number;
//   /**
//    * @description viewport 설정사항
//    */

//   viewport?: any;
//   /**
//    * @description 레이아웃 설정사항
//    * @deprecated 불필요한 정보이기 때문에 추후 삭제
//    */

//   layoutString: string;
//   /**
//    * @description 데이터의 seriesInstanceUID
//    * @deprecated
//    */
//   seriesInstanceUID: string;
//   /**
//    * @description viewport 설정 사항 변경시 callback
//    */
//   onChangeViewport?:
//     | ((viewportId: number, viewport: any, activeTool: any) => void)
//     | null;
//   onRegisteredElement?: any;
// }

// /**
//  * @description GridLayout UI Component Properties
//  *
//  * @interface IViewportStates
//  * @extends {HTMLAttributes<HTMLDivElement>}
//  */
// interface IViewportStates extends HTMLAttributes<HTMLDivElement> {
//   /**
//    * @description DICOM 영상데이터
//    * @deprecated
//    */
//   data: any;
//   /**
//    * @description 이전 DICOM 영상데이터 seriesInstanceUID
//    * @deprecated
//    */
//   prevSeriesInstanceUID: string;
//   /**
//    * @description 로드된 영상갯수
//    * @deprecated
//    */
//   numImagesLoaded: number;
//   /**
//    * @description 현재 출력되는 영상의 인덱스
//    */
//   currentImageIdx: number;
//   /**
//    * @description viewport 설정정보
//    */
//   viewport: any;
//   /**
//    * @description viewport 설정정보
//    * @deprecated
//    */
//   elementStub: any;
//   /**
//    * @description viewport Active 모드 유/무
//    */
//   isActive: boolean;
//   /**
//    * @description 마우스 이벤트 디스패처
//    * @deprecated
//    */
//   mouseEventDispatcher: any;
//   /**
//    * @description 툴 이벤트 디스패처
//    * @deprecated
//    */
//   toolEventDispatcher: any;
//   /**
//    * @description 툴 이벤트 디스패처
//    * @deprecated
//    */
//   newImageEventDispatcher: any;
//   /**
//    * @description DICOM 정보에서 Image Plane 모듈..? (사용하지않음 추후 삭제)
//    * @deprecated
//    */
//   imagePlane: any;
//   /**
//    * @deprecated
//    */
//   mouseXPos: number;
//   /**
//    * @deprecated
//    */
//   mouseYPos: number;
//   presetLevelName: string;
// }

/**
 * @description Viewport UI Class
 *
 * @class Viewport
 * @extends {React.Component<IViewportProps, any>}
 */
//class Viewport extends React.Component<IViewportProps, IViewportStates> {
@inject("sarcopeniaMeasureStore")
class Viewport extends React.Component {
  //static propTypes: PropTypes.InferProps<IViewportProps>;
  componentRedraw = false;
  element = createRef();
  requestUpdateFrame = null;
  frameReady = true; // true -> 렌더링 준비 상태. false -> 렌더링 준비되지 않음(이전 렌더링작업이 종료되지않은경우)
  pendingTick = false; // true -> 이전 Tick가 끝나지 않아, 현재까지 작업이 밀림상태 false -> 계류중인 작업 없음
  _isMounted = false;
  /**
   * subscriber IDs
   *
   * @private
   * @memberof Viewport
   */
  activeChangeSubscriberId = -1;
  clearAllMetadataSubscriberId = -1;
  requestSendToActiveViewSubscriberId = -1;
  requestSendToEmptyViewportId = -1;
  setPresetWindowSubscriberId = -1;
  renderViewSubscriberId = -1;
  renderInvertSubscriberId = -1;
  setDefaultWindowSubscriberId = -1;
  setDynamicWindowSubscriberId = -1;
  setActiveToolSubscriberId = -1;
  setAnnotationActiveToolSubscriberId = -1;
  setScrollIndexAddId = -1;
  setViewPositionInitialize = -1;
  /**
   * default property values
   *
   * @static
   * @memberof Viewport
   */
  static defaultProps = {
    isActive: false,
    onScroll: null,
    scrollIdx: 0,
    viewport: null,
    layoutString: "",
    seriesInstanceUID: "",
    isDisplayDCMTags: true,
    isDisplayOrientationMarkers: true,
    hasContextMenu: true,
    onChangeViewport: null,
    onRegisteredElement: null
  };

  /**
   *Creates an instance of Viewport.
   * @param {*} props
   * @memberof Viewport
   */
  constructor(props) {
    super(props);
    this.state = {
      data: props.data,
      prevSeriesInstanceUID: null,
      numImagesLoaded: 0,
      currentImageIdx: props.scrollIdx,

      viewport:
        props.viewport === null
          ? getDefaultViewport(null, undefined)
          : props.viewport,
      elementStub: null,

      isActive: props.isActive,

      prevWidthRatio: 0,
      prevHeightRatio: 0,

      mouseEventDispatcher: new MouseEventDispatcher(),
      toolEventDispatcher: new ToolEventDispatcher(),
      imagePlane: undefined,
      mouseXPos: -1, //
      mouseYPos: -1,
      presetLevelName: ""
    };
    this.updateAnimationState = this.updateAnimationState.bind(this);
  }
  
  componentWillReceiveProps(nextProps) {
    this.state.currentImageIdx = nextProps.scrollIdx;
    this.state.data = nextProps.data;
    let imageSet = this.state.data;

    if (nextProps.viewport === null) {
      this.state.viewport = getDefaultViewport(null, undefined);
    } else {
      this.state.viewport = nextProps.viewport;
    }

    if (imageSet === undefined) return;

    const domNode = ReactDOM.findDOMNode(this);
    const parentElement = domNode.querySelectorAll(".viewport-element")[0];
    const canvasElement = domNode.querySelectorAll("canvas")[0];

    parentElement.canvas = canvasElement;
    const hasImage = _.get(this.state, "elementStub.image");

    if (!hasImage) {
      resize(parentElement, true);
    } else {
      //parentElement.setAttribute('image', this.state.elementStub.image)
      parentElement.image = this.state.elementStub.image;
      parentElement.viewport = _.cloneDeep(this.state.viewport);

      let elementStub = this.state.elementStub;
      elementStub.viewport = this.state.viewport;
      updateEnabledElement(elementStub);

      if (this.props.onChangeViewport !== null) {
        this.props.onChangeViewport(this.props.identifier, this.state.viewport);
        const { onRegisteredElement } = this.props;
        if (onRegisteredElement !== null) {
          onRegisteredElement(this.props.identifier, elementStub);
        }
      }

      resize(parentElement, false);
    }
  }

  /**
   * @description 컴포넌트가 정상 마운트되었을때, 필요한 이벤트 핸들러들을 등록한다.
   * @method componentDidMount
   * @memberof Viewport
   */
  componentDidMount() {
    this._isMounted = true;
    ///
    /// 1. 이벤트 리스너 등록
    ///
    const element = this.element;
    const elem = ReactDOM.findDOMNode(this);
    elem.addEventListener("keydown", this.handleKeyDown);
    elem.addEventListener("mousemove", this.handleMousemove);
    
    this.state.mouseEventDispatcher.setViewport(this.state.viewport);
    this.state.mouseEventDispatcher.setToolTargetElement(element);
    this.state.mouseEventDispatcher.setViewportObject(this);
    this.state.mouseEventDispatcher.enableMouseEventListen();

    this.state.toolEventDispatcher.setTargetElement(element);
    this.state.toolEventDispatcher.setElementStub(this.state.elementStub);
    this.state.toolEventDispatcher.setupAvailableTools(BuiltInTool);
    this.state.toolEventDispatcher.activateDispatcher();

    this.activeChangeSubscriberId = pubsub.subscribe(
      CustomEvent.Messages.CHANGE_ACTIVE_VIEWPORT,
      this.handleChangeActiveViewport
    );
    this.clearAllMetadataSubscriberId = pubsub.subscribe(
      CustomEvent.Messages.CLEAR_ALL_METADATA,
      //this.handleClearAllView
      this.clearAllView
    );

    this.requestSendToActiveViewSubscriberId = pubsub.subscribe(
      CustomEvent.Messages.REQUEST_SEND_TO_ACTIVEVIEWPORT,
      this.handleRequestData
    );

    this.setPresetWindowSubscriberId = pubsub.subscribe(
      CustomEvent.Messages.CONTRAST_VIEWPORT,
      this.handleSetPresetContrast
    );

    this.renderViewSubscriberId = pubsub.subscribe(
      CustomEvent.Messages.VIEWPORT_RENDER,
      this.handleRequestRender
    );

    this.setScrollIndexAddId = pubsub.subscribe(
      CustomEvent.Messages.SET_SCROLL_INDEX_ADD,
      this.handleSetScrollIndexAdd
    );

    this.setViewPositionInitialize = pubsub.subscribe(
      CustomEvent.Messages.SET_VIEW_POSITION_INITIALIZE,
      this.handleSetViewPositionInitialize
    );

    this.renderInvertSubscriberId = pubsub.subscribe(
      CustomEvent.Messages.RENDER_INVERT,
      this.handleRequestRenderInvert
    );
    this.setDefaultWindowSubscriberId = pubsub.subscribe(
      CustomEvent.Messages.CONTRAST_DEFAULT,
      this.handleContrastDefault
    );
    this.setDynamicWindowSubscriberId = pubsub.subscribe(
      CustomEvent.Messages.CONTRAST_FULL_DYNAMIC,
      this.handleContrastFullDynamic
    );

    this.setActiveToolSubscriberId = pubsub.subscribe(
      CustomEvent.Messages.SET_ACTIVE_TOOL,
      this.handleActivetool
    );
    this.setAnnotationActiveToolSubscriberId = pubsub.subscribe(
      CustomEvent.Messages.SET_ANNOTATION_ACTIVE_TOOL,
      this.handleActiveAnnotationTool
    );
    this.eventHandlerData = [
      {
        eventTarget: window,
        eventType: "resize",
        handler: this.handleWindowResize
      },
      // {
      //   eventTarget: element,
      //   eventType: "resize",
      //   //handler: this.debouncedResize()
      //   handler: this.handleWindowResize
      // },

      {
        eventTarget: element,
        eventType: CustomEvent.EVENTS.MOUSE_WHEEL, // EVENTS.STACK_SCROLL,
        handler: this.handleStackScroll
      },
      {
        eventTarget: element,
        eventType: "onChangeScrollbar", // EVENTS.MOUSE_CLICK,
        handler: this.handleChangeScroll
      },
      // {
      //   eventTarget: element,
      //   eventType: "click", // EVENTS.MOUSE_CLICK,
      //   handler: this.handleMouseClick
      // },
      {
        eventTarget: element,
        eventType: "mousedown", // EVENTS.MOUSE_DOWN,
        handler: this.handleMouseClick
      },
      {
        eventTarget: element,
        eventType: "dblclick", // EVENTS.MOUSE_DOWN,
        handler: this.handleMouseDblClick
      }
    ];

    mouseWheelInput.enable(element);
    this.eventHandlerData.forEach(data => {
      const { eventTarget, eventType, handler } = data;

      eventTarget.addEventListener(eventType, handler.bind(this));
    });

    //stackScrollWheel.activate(element);
    const domNode = ReactDOM.findDOMNode(this);
    const parentElement = domNode.querySelectorAll(".viewport-element")[0];
    const canvasElement = domNode.querySelectorAll("canvas")[0];

    parentElement.canvas = canvasElement;

    const hasImage = _.get(this.state, "elementStub.image");

    if (!hasImage) {
      resize(parentElement, true);
    } else {
      parentElement.setAttribute("image", this.state.elementStub.image);
      parentElement.image = this.state.image;
      parentElement.viewport = this.state.viewport;

      let elementStub = this.state.elementStub;
      elementStub.viewport = this.state.viewport;
      updateEnabledElement(elementStub);
      if (this.props.onChangeViewport !== null) {
        this.props.onChangeViewport(this.props.identifier, this.state.viewport);
        const { onRegisteredElement } = this.props;
        if (onRegisteredElement !== null) {
          onRegisteredElement(this.props.identifier, elementStub);
        }
      }

      resize(parentElement, true);
    }

    ImageRenderedEventDispatcher.activate(element);
    ///
    /// Register measurement Tool
    ///
    //let imageSet = this.state.data;

    // let image = undefined;
    // const hasImage2 = _.get(imageSet, "stack");
    // if (hasImage2) {
    //   image = imageSet.stack[0].frame[0];
    // }
    let metadataCache = new Cache.Metadata();
    const image = metadataCache.getFrame(this.props.seriesID, 0);

    const canvas = getCanvas(element);

    const enabledElement = {
      element,
      canvas,
      //image: undefined, // Will be set once image is loaded
      image: image,
      invalid: false, // True if image needs to be drawn, false if not
      needsRedraw: true,
      options: null,
      layers: [],
      data: {},
      renderingTools: {},
      uuid: Helper.UUID.generateUUID(),
      isDataChanging: false
    };

    if (!hasEnabledElement(element)) {
      addEnabledElement(enabledElement);
      addEnabledElementToolStore(enabledElement.element);
      const { onRegisteredElement } = this.props;
      if (onRegisteredElement !== null) {
        onRegisteredElement(this.props.identifier, enabledElement);
      }
    }

    addTool(LengthTool);
    addTool(RectangleRoiTool);
    addTool(EllipseRoiTool);
    addTool(LineTool);
    addTool(EraseTool);
    addTool(AngleTool);
    addTool(CobbAngleTool);
    addTool(BrushTool); // for segmentation overlay
    // auto generation
    addTool(ReferenceLine);
    // addTool(EraseTool);
    setToolEnabled("ReferenceLines", {
      synchronizationContext: gridLayoutInstance.updateImageSync
    });

    const targetElement = ReactDOM.findDOMNode(this.element);

    targetElement.addEventListener("mousemove", this.handleViewportMousemove);

    //this.renderCanvasAsync();
    this.requestUpdateFrame = requestAnimationFrame(
      this.beforeUpdateAnimationState
    );
    if (this.componentRedraw) {
      this.setState();
      this.forceUpdate();
    }

    const { activeTool, activeColor } = this.props;

    const annotation = [
      "length, rectangle",
      "ellipse",
      "angle",
      "cobb-angle",
      "Pencil",
      "Erase",
    ];

    if (
      typeof activeTool === "string" &&
      activeTool !== "none" &&
      activeTool !== ""
    ) {
      if (annotation.includes(activeTool)) {
        this.handleActiveAnnotationTool(activeTool, "");
      } else {
        this.handleActivetool(activeTool, "");
      }
    }
  }

  /**
   * @description
   * @method componentDidUpdate
   * @memberof Viewport
   */
  componentDidUpdate() {
    this._isMounted = false;

    const domNode = ReactDOM.findDOMNode(this);
    const parentElement = domNode.querySelectorAll(".viewport-element")[0];
    const canvasElement = domNode.querySelectorAll("canvas")[0];

    parentElement.canvas = canvasElement;
    //parentElement.image = this.state.elementStub.image
    const hasImage = _.get(this.state, "elementStub.image");

    if (!hasImage) {
      resize(parentElement, true);
    } else {
      parentElement.image = this.state.elementStub.image;
      parentElement.viewport = this.state.viewport;
      let elementStub = this.state.elementStub;
      elementStub.viewport = this.state.viewport;
      updateEnabledElement(elementStub);
      if (this.props.onChangeViewport !== null) {
        this.props.onChangeViewport(this.props.identifier, this.state.viewport);
        const { onRegisteredElement } = this.props;
        if (onRegisteredElement !== null) {
          onRegisteredElement(this.props.identifier, elementStub);
        }
      }

      resize(parentElement, false);
    }
    let enabledElement = getEnabledElement(this.element);
    enabledElement.needsRedraw = true;

    if (
      !(this.props.width === this.state.prevWidthRatio) ||
      !(this.props.height === this.state.prevHeightRatio)
    ) {
      this.setState({
        prevWidthRatio: this.props.width,
        prevHeightRatio: this.props.height
      });
    }

    if (this.componentRedraw) {
      this.setState();
    }

    // const { activeTool } = this.props;
    const { activeTool, activeColor } = this.props;

    const annotation = [
      "length, rectangle",
      "ellipse",
      "angle",
      "cobb-angle",
      "Pencil",
      "Erase",
    ];


    if (
      typeof activeTool === "string" &&
      activeTool !== "none" &&
      activeTool !== ""
    ) {
      if (annotation.includes(activeTool)) {
        // console.log("커스텀 펜 등록 activeTool: ", activeTool);
        this.handleActiveAnnotationTool(activeTool, "");
      } else {
        // console.log("커스텀 펜 등록 activeTool: ", activeTool);
        this.handleActivetool(activeTool, "");
      }
    }
  }

  /**
   * @description 모든 메시지 핸들러를 해제
   * @method ComponentWillUnmount
   * @memberof Viewport
   */
  componentWillUnmount = () => {
    cancelAnimationFrame(this.requestUpdateFrame);

    const element = this.element;

    const elem = ReactDOM.findDOMNode(this);
    elem.removeEventListener("keydown", this.handleKeyDown);
    elem.removeEventListener("mousemove", this.handleMousemove);
    const targetElement = ReactDOM.findDOMNode(this.element);
    targetElement.removeEventListener(
      "mousemove",
      this.handleViewportMousemove
    );

    this.eventHandlerData.forEach(data => {
      const { eventTarget, eventType, handler } = data;

      eventTarget.removeEventListener(eventType, handler.bind(this));
    });

    pubsub.unsubscribe(this.activeChangeSubscriberId);
    pubsub.unsubscribe(this.clearAllMetadataSubscriberId);
    pubsub.unsubscribe(this.requestSendToActiveViewSubscriberId);
    pubsub.unsubscribe(this.setPresetWindowSubscriberId);
    pubsub.unsubscribe(this.renderViewSubscriberId);
    pubsub.unsubscribe(this.renderInvertSubscriberId);
    pubsub.unsubscribe(this.setDefaultWindowSubscriberId);
    pubsub.unsubscribe(this.setViewPositionInitialize);

    pubsub.unsubscribe(this.handleSetScrollIndexAdd);
    pubsub.unsubscribe(this.setActiveToolSubscriberId);
    pubsub.unsubscribe(this.setAnnotationActiveToolSubscriberId);

    ImageRenderedEventDispatcher.deactivate(element);
  };

  beforeUpdateAnimationState = () => {
    if (this.frameReady === false) {
      this.pendingTick = true;
      this.requestUpdateFrame = requestAnimationFrame(
        this.beforeUpdateAnimationState
      );
      return;
    }
    this.updateAnimationState();
  };
  updateAnimationState() {
    this.frameReady = false;

    const ret = this.renderCanvasAsync();
    if (ret !== null) {
      ret.then(res => {
        this.afterUpdateAnimationState();
      });
    } else {
      this.frameReady = true;
    }

    this.requestUpdateFrame = requestAnimationFrame(
      this.beforeUpdateAnimationState
    );
  }

  handleViewportMousemove = event => {
    let imageSet = this.state.data;
    let index =
      this.state.currentImageIdx === -1 ? 0 : this.state.currentImageIdx;

    // const hasImage = _.get(imageSet, "stack");
    // if (!hasImage) {
    //   return;
    // }

    // let image = imageSet.stack[0].frame[index];
    // if (image === undefined) {
    //   return;
    // }

    let metadataCache = new Cache.Metadata();
    const image = metadataCache.getFrame(this.props.data, index);

    if (!_.get(this.state.elementStub, "canvas")) {
      return;
    }
    const pageX = event.pageX;
    const pageY = event.pageY;

    if (this.state.image === null || this.state.image === undefined) {
      this.state.image = imageSet;
    }
    if (!_.get(this.state.elementStub, "image")) {
      return;
    }
    const imageCoord = math.coordinate.pageToPixel(
      this.state.elementStub,
      pageX,
      pageY
    );

    if (!_.get(image, "columns") || !_.get(image, "rows")) {
      return;
    }

    if (
      imageCoord.x < 0 ||
      imageCoord.x >= image.columns ||
      imageCoord.y < 0 ||
      imageCoord.y >= image.rows
    ) {
      this.setState({ mouseXPos: -1, mouseYPos: -1 });
      return;
    }
    this.setState({
      mouseXPos: parseInt(imageCoord.x),
      mouseYPos: parseInt(imageCoord.y)
    });
    //this.setState(this.state);
  };

  afterUpdateAnimationState = () => {
    this.frameReady = true;
    if (this.pendingTick) {
      this.pendingTick = false;
    }
  };

  /**
   * @description 화면 크기 변경시, viewport 크기 변환
   * @method debouncedResize
   * @memberof Viewport
   */
  debouncedResize = debounce(() => {
    if (this.element === null || this.element === undefined) return;

    if (
      this.element.clientHeight === null ||
      this.element.clientHeight === undefined
    ) {
      return;
    }
    if (!_.get(this.state.elementStub, "image")) {
      return;
    }

    this.element.image = this.state.elementStub.image;
    const hasImage = _.get(this.state, "elementStub.image");

    if (!hasImage) {
      resize(this.element, true);
    } else {
      let enabledElement = getEnabledElement(this.element);
      enabledElement.needsRedraw = true;
      resize(this.element);
    }
  }, 25);

  /**
   * @description Active 모드 viewport 변경. (Active모드는 한개 viewport만 가능)
   * @method handleChangeActiveViewport
   * @memberof Viewport
   */
  handleChangeActiveViewport = (activeViewportIdx, msg) => {
    const { identifier } = this.props;
    let { isActive } = this.state;

    if (identifier === activeViewportIdx) {
      isActive = true;
    } else {
      isActive = false;
    }

    this.setState({
      isActive: isActive
    });
  };

  handleMousemove = event => {
    cursorPageX = event.pageX;
    cursorPageY = event.pageY;
  };

  /**
   *
   *
   * @memberof Viewport
   */
  handleRemoveTool = event => {};
  /**
   *
   *
   * @memberof Viewport
   */
  handleKeyDown = event => {
    if (event.keyCode === 46) {
      //let tools = getActiveToolsForElement(this.element, getters.mouseTools());
      let tools = getToolsForElement(this.element, getters.mouseTools());

      let imageCorod = math.coordinate.pageToPixel(
        this.state.elementStub,
        cursorPageX,
        cursorPageY
      );
      let coords = math.coordinate.pixelToCanvas(
        this.state.elementStub,
        imageCorod
      );

      // NEAR TOOL?
      const annotationToolsWithPointNearClick = tools.filter(
        function(tool) {
          const toolState = getToolState(this.element, tool.name);
          const isNearPoint =
            toolState &&
            toolState.data &&
            tool.pointNearTool &&
            toolState.data.some(data =>
              tool.pointNearTool(this.element, data, coords, "mouse")
            );

          return isNearPoint;
        }.bind(this)
      );

      if (annotationToolsWithPointNearClick.length > 0) {
        const firstToolNearPoint = annotationToolsWithPointNearClick[0];
        const toolState = getToolState(this.element, firstToolNearPoint.name);
        const firstAnnotationNearPoint = toolState.data.find(data =>
          firstToolNearPoint.pointNearTool(this.element, data, coords)
        );

        removeToolState(
          this.element,
          firstToolNearPoint.name,
          firstAnnotationNearPoint
        );
        this.setState(this.state);

        let enabledElement = getEnabledElement(this.element);
        enabledElement.needsRedraw = true;

        return;
      }
    }
  };

  /**
   * @description Provider에 데이터 요청
   * @method handleClearAll
   * @memberof Viewport
   */

  handleRequestData = (payload, msg) => {
    if (this.state.isActive === false) {
      return;
    }

    const itemSerieskey = payload;

    payload = {
      viewportIndex: this.props.identifier,
      seriesID: itemSerieskey
    };
    pubsub.publish(CustomEvent.Messages.DELIVER_DATA_TO_VIEWPORT, payload);
  };

  handleActiveAnnotationTool = (toolName, activeColor, msg) => {
    const { toolEventDispatcher } = this.state;
    setToolActive(toolName, { mouseButtonMask: 1 });
    toolEventDispatcher.setActivateTool("none");
  };

  // handleActiveAnnotationTool = (data, msg) => {
  //   const { toolEventDispatcher } = this.state;
    
  //   let toolName = "";
  //   let color = null;
    
  //   if (typeof data === "object") {
  //     toolName = data.toolName;
  //     color = data.color;
  //     console.log("[toolName]:" ,toolName)
  //   } else {
  //     toolName = data;
  //   }
  //   toolEventDispatcher.setActivateTool(toolName, color);
  //   let tools = getActiveToolsForElement(this.element, getters.mouseTools());
  //   tools = tools.filter(tool => tool.options.isMouseActive);

  //   if (tools.length > 0) {
  //     setToolPassive(tools[0].name);
  //   }
  // };

  /**
   * @description Contrast Preset 적용
   * @deprecated
   * @method handleSetPresetContrast
   * @memberof Viewport
   */
  handleSetPresetContrast = (data, msg) => {
    if (this.state.isActive === false) {
      return;
    }
    let imageSet = this.state.data;
    let index =
      this.state.currentImageIdx === -1 ? 0 : this.state.currentImageIdx;
    if (imageSet === null || imageSet === undefined) {
      return;
    }

    let metadataCache = new Cache.Metadata();
    //const image = metadataCache.getFrame(this.props.seriesID, index);
    const image = metadataCache.getFrame(this.props.data, index);

    if (!image) {
      return;
    }

    this.state.viewport.voi.windowCenter = data["wl"];
    this.state.viewport.voi.windowWidth = data["ww"];
    this.state.presetLevelName = data["name"];

    let elementStub = this.state.elementStub;
    elementStub.viewport = this.state.viewport;
    updateEnabledElement(elementStub);
    if (this.props.onChangeViewport !== null) {
      this.props.onChangeViewport(this.props.identifier, this.state.viewport);
      const { onRegisteredElement } = this.props;
      if (onRegisteredElement !== null) {
        onRegisteredElement(this.props.identifier, elementStub);
      }
    }

    this.setState(this.state);
    let enabledElement = getEnabledElement(this.element);
    enabledElement.needsRedraw = true;
  };

  handleRequestRenderInvert = (data, msg) => {
    if (this.state.isActive === false) {
      return;
    }
    this.state.viewport.invert = !this.state.viewport.invert;

    let elementStub = this.state.elementStub;
    if (elementStub === null || elementStub === undefined) {
      return;
    }

    if (this.props.viewport !== null) {
      elementStub.viewport = this.state.viewport;
    }
    if (this.props.onChangeViewport !== null) {
      updateEnabledElement(elementStub);
      this.props.onChangeViewport(this.props.identifier, this.state.viewport);
      const { onRegisteredElement } = this.props;
      if (onRegisteredElement !== null) {
        onRegisteredElement(this.props.identifier, elementStub);
      }
    }
    this.setState(this.state);
    let enabledElement = getEnabledElement(this.element);
    enabledElement.needsRedraw = true;
    pubsub.publish(CustomEvent.Messages.CONTRAST_DROPDOWN_RENDER, {
      selectedValue: "ct-Negative"
    });
  };

  handleContrastDefault = (data, msg) => {
    if (this.state.isActive === false) {
      return;
    }
    let imageSet = this.state.data;
    let frameIndex =
      this.state.currentImageIdx === -1 ? 0 : this.state.currentImageIdx;
    if (imageSet === null || imageSet === undefined) {
      return;
    }

    let metadataCache = new Cache.Metadata();
    const image = metadataCache.getFrame(this.props.data, frameIndex);

    // let image = imageSet.stack[0].frame[frameIndex];
    // if (image === undefined) {
    //   return;
    // }

    this.state.viewport.voi.windowCenter = image.windowCenter;
    this.state.viewport.voi.windowWidth = image.windowWidth;
    this.state.presetLevelName = "D";

    let elementStub = this.state.elementStub;
    elementStub.viewport = this.state.viewport;
    updateEnabledElement(elementStub);
    if (this.props.onChangeViewport !== null) {
      this.props.onChangeViewport(this.props.identifier, this.state.viewport);
      const { onRegisteredElement } = this.props;
      if (onRegisteredElement !== null) {
        onRegisteredElement(this.props.identifier, elementStub);
      }
    }

    this.setState(this.state);
    let enabledElement = getEnabledElement(this.element);
    enabledElement.needsRedraw = true;
  };

  /**
   * @method handleContrastFullDynamic
   *
   * @ref @link "https://www.radiantviewer.com/dicom-viewer-forum/calculation-full-dynamic-window-values/368/"
   * @memberof Viewport
   */
  handleContrastFullDynamic = (data, msg) => {
    if (this.state.isActive === false) {
      return;
    }
    let imageSet = this.state.data;
    let frameIndex =
      this.state.currentImageIdx === -1 ? 0 : this.state.currentImageIdx;
    if (imageSet === null || imageSet === undefined) {
      return;
    }
    // let image = imageSet.stack[0].frame[frameIndex];
    // if (image === undefined) {
    //   return;
    // }
    let metadataCache = new Cache.Metadata();
    const image = metadataCache.getFrame(this.props.data, frameIndex);

    // WW = vmax - vmin
    const ww = image.minMax[1] - image.minMax[0];
    const wl = image.minMax[0] + image.windowWidth / 2;
    // WL = vmin + WW / 2
    this.state.viewport.voi.windowCenter = wl;
    this.state.viewport.voi.windowWidth = ww;
    this.state.presetLevelName = "F";

    let elementStub = this.state.elementStub;
    elementStub.viewport = this.state.viewport;
    updateEnabledElement(elementStub);
    if (this.props.onChangeViewport !== null) {
      this.props.onChangeViewport(this.props.identifier, this.state.viewport);
      const { onRegisteredElement } = this.props;
      if (onRegisteredElement !== null) {
        onRegisteredElement(this.props.identifier, elementStub);
      }
    }

    this.setState(this.state);

    if (this.element !== null && this.element !== undefined) {
      let enabledElement = getEnabledElement(this.element);
      enabledElement.needsRedraw = true;
    }
  };

  /**
   * @description 강제 재 랜더링
   * @deprecated
   * @method handleRequestRender
   * @memberof Viewport
   */

  handleRequestRender = (data, msg) => {
    //this.setState({ state: this.state });
    if (this.props.identifier === data) {
      if (
        this.state.elementStub === null ||
        this.state.elementStub === undefined
      ) {
        return;
      }
      this.state.elementStub.needsRedraw = true;
    }
  };

  /**
   * @description 활성화 도구 변경
   * @deprecated
   * @method handleActivetool
   * @memberof Viewport
   */
  handleActivetool = (toolName, msg) => {
    const { toolEventDispatcher } = this.state;
    toolEventDispatcher.setActivateTool(toolName);
    let tools = getActiveToolsForElement(this.element, getters.mouseTools());
    tools = tools.filter(tool => tool.options.isMouseActive);
    if (tools.length > 0) {
      //console.log("setToolPassive");
      setToolPassive(tools[0].name);
    }
  };

  // handleActiveAnnotationTool = (toolName, msg) => {
  //   const { toolEventDispatcher } = this.state;
  //   setToolActive(toolName, { mouseButtonMask: 1 });
  //   toolEventDispatcher.setActivateTool("none");
  // };


  /**
   * @description 현재 viewport Active모드 변경
   * @deprecated
   * @method setViewportActive
   * @memberof Viewport
   */
  setViewportActive = () => {
    pubsub.publish(
      CustomEvent.Messages.CHANGE_ACTIVE_VIEWPORT,
      this.props.identifier
    );
  };

  /**
   * @description viewport 설정사항 변경
   * @method setViewport
   * @memberof Viewport
   */
  //setViewport = viewport => {
  setViewport = (viewport, activeTool) => {
    let elementStub = this.state.elementStub;
    elementStub.viewport = _.cloneDeep(viewport);
    updateEnabledElement(this.state.elementStub);
    if (this.props.onChangeViewport !== null) {
      this.props.onChangeViewport(
        this.props.identifier,
        //this.state.viewport,
        _.cloneDeep(viewport),
        activeTool
      );
      const { onRegisteredElement } = this.props;
      if (onRegisteredElement !== null) {
        onRegisteredElement(this.props.identifier, elementStub);
      }
    }
    this.state.viewport = _.cloneDeep(viewport);
    // this.setState({
    //   viewport: _.cloneDeep(viewport)
    // });
    let enabledElement = getEnabledElement(this.element);
    enabledElement.needsRedraw = true;
  };

  /**
   * @description viewport 설정사항 리턴
   * @deprecated
   * @method getElementStub
   * @memberof Viewport
   */
  getElementStub = () => {
    return this.state.elementStub;
  };

  handleWindowResize = event => {
    this.setState({});
    this.debouncedResize();
  };

  handleSetViewPositionInitialize = (paylaod, msg) => {
    const { data } = this.state;

    if (!this.state.isActive) {
      return;
    }

    if (data === undefined) {
      return;
    }
    this.state.viewport.scale = 1.0;
    this.state.viewport.translation.x = 0;
    this.state.viewport.translation.y = 0;

    Canvas.resize(this.element, true);

    let enabledElement = getEnabledElement(this.element);
    enabledElement.needsRedraw = true;
  };

  handleSetScrollIndexAdd = (payload, msg) => {
    if (!this.state.isActive) {
      return;
    }

    const { displacement } = payload;
    const moveIndex = displacement;

    const { currentImageIdx, data } = this.state;
    const { onScroll, identifier } = this.props;
    let newImageIndex = currentImageIdx + moveIndex;

    if (data === undefined) {
      return;
    }

    let metadataCache = new Cache.Metadata();
    const numberOfImages = metadataCache.getNumOfFrame(data);
    newImageIndex = clip(newImageIndex, 0, numberOfImages - 1);

    const isNotChange = currentImageIdx === newImageIndex;

    if (onScroll !== null) {
      onScroll(identifier, newImageIndex);
    }

    this.setState({
      currentImageIdx: newImageIndex
    });

    let enabledElement = getEnabledElement(this.element);
    //if (!isNotChange) {
    enabledElement.needsRedraw = true;
    //}

    CustomEvent.triggerEvent(
      this.element,
      CustomEvent.EVENTS.IMAGE_RENDERED,
      this.state.elementStub
    );

    if (!isNotChange) {
      ///Test
      CustomEvent.triggerEvent(
        this.element,
        CustomEvent.EVENTS.SCROLL_INDEX_CHANGED,
        //this.state.elementStub
        newImageIndex
      );
    }
  };

  /**
   * @description viewport에서 스크롤링시 발생하는 이벤트 처리 핸들러
   * @method handleStackScroll
   * @memberof Viewport
   */
  handleStackScroll = event => {
    let eventData = event.detail;
    const moveIndex = -eventData.direction;

    const { currentImageIdx, data } = this.state;
    const { onScroll, identifier } = this.props;
    let newImageIndex = currentImageIdx + moveIndex;

    if (data === undefined) {
      return;
    }

    let metadataCache = new Cache.Metadata();
    const numberOfImages = metadataCache.getNumOfFrame(data);
    newImageIndex = clip(newImageIndex, 0, numberOfImages - 1);

    if (onScroll !== null) {
      onScroll(identifier, newImageIndex);
    }

    const isNotChange = currentImageIdx === newImageIndex;

    this.setState({
      currentImageIdx: newImageIndex
    });

    let enabledElement = getEnabledElement(this.element);
    if (!isNotChange) {
      enabledElement.needsRedraw = true;
    }

    // CustomEvent.triggerEvent(
    //   this.element,
    //   CustomEvent.EVENTS.IMAGE_RENDERED,
    //   this.state.elementStub
    // );
    if (!isNotChange) {
      CustomEvent.triggerEvent(
        this.element,
        CustomEvent.EVENTS.SCROLL_INDEX_CHANGED,
        newImageIndex
        //this.state.elementStub
      );
    }
  };

  /**
   * @description 마우스 클릭 이벤트 발생시 처리 핸들리
   * @method handleMouseClick
   * @param event 이벤트 발생 정보
   * @memberof Viewport
   */
  handleMouseClick = event => {
    this.setViewportActive();
  };

  /**
   * @description 마우스 더블클릭 이벤트 발생시 처리 핸들러
   * @method handleMouseDblClick
   * @param event 이벤트 발생 정보
   * @memberof Viewport
   */
  handleMouseDblClick = event => {
    const { data } = this.state;

    ///
    /// 0. 데이터가 없는 View에 대해서는 동작하지 않는다.
    ///
    if (data === undefined) {
      return;
    }

    let { isActive } = this.state;
    ///
    /// 1. activate viewport
    ///
    isActive = true;
    ///
    /// 2. publish view one viewport
    ///
    pubsub.publish(
      CustomEvent.Messages.VIEW_ONE_VIEWPORT,
      this.props.identifier
    );
    this.setState({ isActive: isActive });
    let enabledElement = getEnabledElement(this.element);
    enabledElement.needsRedraw = true;
  };

  /**
   * @description scroll 이동 이벤트 발생시, 현재 스크롤 위치에
   * 맞는 DICOM 영상으로 갱신한다.
   * @method handleChangeScroll
   * @param event 스크롤 이벤트 정보
   * @param data
   * @memberof Viewport
   */
  handleChangeScroll = function(event, data) {
    let eventData = event.detail;

    let { currentImageIdx } = this.state;
    //const { onScroll, id } = this.props;
    const { onScroll, identifier } = this.props;

    let metadataCache = new Cache.Metadata();
    const numOfFrame = metadataCache.getNumOfFrame(this.props.data);

    const newScrollIndex = eventData.newImageIndex;
    const newImageIdIndex = clip(newScrollIndex, 0, numOfFrame - 1);

    if (onScroll !== null) {
      onScroll(identifier, newImageIdIndex);
    }

    currentImageIdx = newImageIdIndex;

    this.setState({
      currentImageIdx: currentImageIdx
    });

    let enabledElement = getEnabledElement(this.element);
    enabledElement.needsRedraw = true;

    CustomEvent.triggerEvent(
      this.element,
      CustomEvent.EVENTS.IMAGE_RENDERED,
      this.state.elementStub
    );

    CustomEvent.triggerEvent(
      this.element,
      CustomEvent.EVENTS.SCROLL_INDEX_CHANGED,
      newImageIdIndex
      //this.state.elementStub
    );
  };

  /**
   * @method handleContextMenu
   * @description 우 클릭시 발생하는 기본 동작을 막는다.
   * @memberof Viewport
   */
  handleContextMenu = e => {
    // 우측 마우스를 눌렀을때, 발생하는 기본 동작을 막는다.
    e.preventDefault();
    const { elementStub } = this.state;

    if (!_.get(elementStub, "canvas")) {
      return;
    }
    let tools = getActiveToolsForElement(this.element, getters.mouseTools());

    if (
      !_.get(this.state.elementStub, "image.pixelSpacing[0]") ||
      !_.get(this.state.elementStub, "image.pixelSpacing[1]")
    ) {
      return;
    }

    let imageCorod = math.coordinate.pageToPixel(
      this.state.elementStub,
      cursorPageX,
      cursorPageY
    );
    let coords = math.coordinate.pixelToCanvas(
      this.state.elementStub,
      imageCorod
    );

    // NEAR TOOL?
    const annotationToolsWithPointNearClick = tools.filter(tool => {
      const toolState = getToolState(this.element, tool.name);
      const isNearPoint =
        toolState &&
        toolState.data &&
        tool.pointNearTool &&
        toolState.data.some(data =>
          tool.pointNearTool(this.element, data, coords, "mouse")
        );

      return isNearPoint;
    });

    if (annotationToolsWithPointNearClick.length > 0) {
      const id = this.getToolContextMenuId();
      if (id === "") {
        return;
      }

      const contextMenuNode = document.getElementsByClassName(id)[0];
      //contextMenuNode.style.top = "100"; // cursorPageY;
      contextMenuNode.style.className =
        "react-contextmenu react-contextmenu--visible viewport-tool-menuID-0";
      contextMenuNode.style.top = cursorPageY;
      contextMenuNode.style.left = cursorPageX;
      contextMenuNode.style.opacity = 1;

      return;
    }
  };

  /**
   * @method getContextMenuId
   * @description Context Menu의 ID 리턴
   * @returns Context Menu의 ID 리턴
   * @memberof Viewport
   */
  getContextMenuId() {
    const { data } = this.state;
    const { identifier } = this.props;

    if (typeof data === undefined) {
      return "viewport-menuID-none";
    }
    if (data === undefined || data === null) {
      return "viewport-menuID-none";
    }
    return "viewport-menuID-" + identifier;
  }

  /**
   * @method getContextMenuId
   * @description Context Menu의 ID 리턴
   * @returns Context Menu의 ID 리턴
   * @memberof Viewport
   */
  getToolContextMenuId() {
    const { data } = this.state;
    const { identifier } = this.props;

    if (typeof data === undefined) {
      return "viewport-tool-menuID-none";
    }
    if (data === undefined || data === null) {
      return "viewport-tool-menuID-none";
    }
    return "viewport-tool-menuID-" + identifier;
  }

  /**
   * @method getActiveClass
   * @description Active상태인 경우(마우스로 클릭한 상태), HTML Class Name으로 active 리턴
   * Active 상태가 아니면, 빈 문자열 리턴
   * @returns
   *    UI가 Active 상태 - "active"
   *    UI가 Non-Active 상태 - ""
   * @memberof Viewport
   */
  getActiveClass() {
    const { isActive } = this.state;
    if (isActive === true) {
      return "active";
    } else {
      return "";
    }
  }
  getViewport(element) {
    const viewport = this.state.viewport;

    if (viewport === undefined) {
      return;
    }

    // Return a copy of the viewport
    return Object.assign({}, viewport);
  }

  getImage = () => {
    let imageSet = this.state.data;
    if (imageSet === undefined) {
      return null;
    }

    let index =
      this.state.currentImageIdx === -1 ? 0 : this.state.currentImageIdx;
    let metadataCache = new Cache.Metadata();
    const image = metadataCache.getFrame(this.props.data, index);

    // let image = imageSet.stack[0].frame[index];
    // if (image === undefined) {
    //   return null;
    // }

    return image;
  };

  getImageIndex = () => {
    let imageSet = this.state.data;
    if (imageSet === undefined) {
      return null;
    }

    let imageIndex =
      this.state.currentImageIdx === -1 ? 0 : this.state.currentImageIdx;

    return imageIndex;
  };

  getValue = () => {
    let imageSet = this.state.data;
    if (imageSet === undefined) {
      return "";
    }

    let index =
      this.state.currentImageIdx === -1 ? 0 : this.state.currentImageIdx;
    let metadataCache = new Cache.Metadata();
    const image = metadataCache.getFrame(this.props.data, index);

    //let image = imageSet.stack[0].frame[index];
    if (image === undefined) {
      return "";
    }
    if (this.element.current === null) {
      return "";
    }
    if (!_.get(this.element, "image")) {
      return "";
    }
    if (!_.get(this.element, "image.columns")) {
      return "";
    }
    //this.element.image = image;
    const { mouseXPos, mouseYPos } = this.state;

    if (!image) {
      return "";
    }

    const text = getPixelValue(mouseXPos, mouseYPos, this.element, image.color);
    return text;
  };

  getLevelPresetName = () => {
    if (gridLayoutInstance === null || gridLayoutInstance === undefined) {
      return "";
    }

    const selectedValue = gridLayoutInstance.getContrastOptionById(
      this.props.identifier
    );
    if (typeof selectedValue !== "string") {
      return "";
    }
    if (selectedValue === "") {
      return "";
    }
    this.state.presetLevelName = selectedValue;

    return "[" + selectedValue + "]";
  };

  /**
   * @method handleRemoveData
   * @description viewport에 데이터 삭제 명령시, 처리 핸들러
   * @todo Pub/Sub 사용 걷어내야함.
   * @memberof Viewport
   */
  handleRemoveData = (event, removedData) => {
    /// 교체 상황 발생
    const parameters = {
      title: "Warning",
      message: Constants.DialogMessage.ConfirmUnloadDataOnDCMView,
      buttonType: "YESNO",
      hasCloseButton: false,
      hasTodayOffButton: false,
      handleYesClick: function() {
        this.removeData(removedData);
      }.bind(this)
    };
    FloatMessageBox(parameters);
  };

  removeData = removeData => {
    const { data } = this.state;
    const { identifier } = this.props;
    ///
    /// 데이터가 없는경우, 예외처리
    ///
    if (typeof data === undefined) {
      return;
    }

    ///
    /// viewport 설정 정보를 제거한다.
    ///
    const viewportId = identifier;
    this.setState({
      viewport: getDefaultViewport(null, undefined)
    });

    ///
    /// 데이터 삭제 메세지 전달
    ///
    this.state.elementStub = null;
    this.state.data = undefined;
    pubsub.publish(CustomEvent.Messages.REMOVE_VIEWPORT, viewportId);
    clearElementState(this.element);
    let enabledElement = getEnabledElement(this.element);

    enabledElement.needsRedraw = true;
  };

  handleClearAllView = (removedData, event) => {
    //this.clearAllView(removedData);
    //return;
    //const blnCookie = Helper.Cookie.getCookie("TodayMessageBoxOff");
    // if (
    //   !(blnCookie === "") &&
    //   !(blnCookie === undefined || blnCookie === null)
    // ) {
    //   this.clearAllView(removedData);
    //   return;
    // }
    const parameters = {
      title: "Warning",
      message: Constants.DialogMessage.ConfirmUnloadAllDataOnDCMView,
      buttonType: "YESNO",
      hasCloseButton: false,
      hasTodayOffButton: true,
      handleYesClick: function() {
        this.clearAllView(removedData);
      }.bind(this)
    };
    FloatMessageBox(parameters);
  };

  clearAllView = () => {
    const { identifier } = this.props;
    const viewportId = identifier;
    ///
    /// 데이터 삭제 메세지 전달
    ///
    this.state.elementStub = null;
    this.state.data = undefined;
    pubsub.publish(CustomEvent.Messages.CLEAR_VIEWPORT, viewportId);
    let enabledElement = getEnabledElement(this.element);

    enabledElement.needsRedraw = true;
  };

  /**
   * @description 데이터를 캔버스에 비동기로 그린다.
   * @method renderCanvasAsync
   *
   * @returns
   * @memberof Viewport
   */
  renderCanvasAsync() {
    const domNode = ReactDOM.findDOMNode(this);
    const canvasElement = domNode.querySelectorAll("canvas")[0];

    const { data, currentImageIdx, viewport } = this.state;
    const { onChangeViewport } = this.props;
    ///
    /// 로드된 데이터가 없다면, 검은색으로 채운다.
    ///
    let enabledElement = getEnabledElement(this.element);
    if (data === undefined && enabledElement.needsRedraw) {
      const context = canvasElement.getContext("2d");
      context.setTransform(1, 0, 0, 1, 0, 0);
      context.fillStyle = "black";
      context.fillRect(0, 0, canvasElement.width, canvasElement.height);

      enabledElement.needsRedraw = false;

      return null;
    }

    //let enabledElement = getEnabledElement(this.element);
    if (!enabledElement.needsRedraw) {
      return null;
    }

    return new Promise((resolve, reject) => {
      try {
        const clipImageIdx = currentImageIdx === -1 ? 0 : currentImageIdx;

        let metadataCache = new Cache.Metadata();
        const image = metadataCache.getFrame(this.props.data, clipImageIdx);

        if (!image) {
          resolve();
        }

        image.width = image.columns;
        image.height = image.rows;

        const uuid = enabledElement.uuid;

        let elementStub = renderToCanvas(canvasElement, image, viewport, uuid);
        elementStub.element = this.element;
        const newViewport = elementStub.viewport;

        elementStub.needsRedraw = false;
        updateEnabledElement(elementStub);
        if (onChangeViewport !== null) {
          onChangeViewport(this.props.identifier, newViewport, 0);
          const { onRegisteredElement } = this.props;
          if (onRegisteredElement !== null) {
            onRegisteredElement(this.props.identifier, elementStub);
          }
        }

        this.state.elementStub = elementStub;
        this.state.currentImageIdx = clipImageIdx;
        this.state.viewport = newViewport;
        //addEnabledElement(this.state.elementStub);

        CustomEvent.triggerEvent(
          this.element,
          CustomEvent.EVENTS.IMAGE_RENDERED,
          elementStub
        );
        resolve();
      } catch (error) {
        reject(error);
      }
    });
  }

  /**
   * @method renderOverlaySlogan
   * @description Slogan 이미지 UI 렌더링
   * @returns
   * @memberof Viewport
   */

  //forTemp
  permanentHidden = false;
  renderOverlaySlogan() {
    if (this.permanentHidden === true) {
      return;
    }
    const { data } = this.state;
    if (data === undefined) {
      return <OverlayInputGuide />;
    } else {
      this.permanentHidden = true;
    }
    return;
  }

  /**
   * @method renderViewportOverlay
   * @description DICOM Tag Overlay UI 컴포넌트 렌더링
   * @returns
   * @memberof Viewport
   */
  renderViewportOverlay() {
    const { isDisplayDCMTags, layoutString, seriesInstanceUID } = this.props;
    if (this.componentRedraw) {
      this.componentRedraw = false;
    }
    if (!isDisplayDCMTags) {
      return false;
    }

    if (!this.element) {
      return false;
    }

    if (
      this.element.clientHeight === null ||
      this.element.clientHeight === undefined
    ) {
      if (this.props.data) {
        this.componentRedraw = true;
      }

      return false;
    }

    const {
      viewport,
      data,
      currentImageIdx,
      mouseXPos,
      mouseYPos
    } = this.state;
    /** Max Tag Size */
    const baseFontSize = "15";
    const baseLineHeight = "26";
    const clientShortSideLength = Math.min(
      this.element.clientHeight,
      this.element.clientWidth
    );
    const ratio = Math.max(
      Math.min(clientShortSideLength / 30, baseFontSize) / baseFontSize,
      0.3
    );

    if (data !== undefined) {
      let metadataCache = new Cache.Metadata();
      const numOfFrame = metadataCache.getNumOfFrame(this.props.data);
      const canvas = getCanvas(this.element);
      return (
        <DCMTagOverlay
          viewport={viewport}
          imageIndex={currentImageIdx}
          numImages={numOfFrame}
          imageId={seriesInstanceUID}
          stack={data}
          layoutString={layoutString}
          parentElement={canvas}
          style={{
            fontSize: baseFontSize + "px",
            transform: `scale(${ratio})`,
            lineHeight: baseLineHeight * ratio + "px"
          }}
          fontSize={baseFontSize}
          mousePos={{ x: mouseXPos, y: mouseYPos }}
          value={this.getValue()}
          levelPresetName={this.getLevelPresetName()}
        />
      );
    }
    return;
  }

  renderOrientationMarkers = () => {
    const { isDisplayOrientationMarkers } = this.props;
    if (!isDisplayOrientationMarkers) {
      return;
    }
    let metadataCache = new Cache.Metadata();
    const rowCosines = metadataCache.getRowCosines(this.props.data);
    const columnCosines = metadataCache.getColumnCosines(this.props.data);

    const baseFontSize = "15";
    const baseLineHeight = "26";
    const clientShortSideLength = Math.min(
      this.element.clientHeight,
      this.element.clientWidth
    );
    const ratio = Math.max(
      Math.min(clientShortSideLength / 30, baseFontSize) / baseFontSize,
      0.3
    );

    return (
      <ViewportOrientationMarkers
        styles={{
          fontSize: baseFontSize + "px",
          transform: `scale(${ratio})`,
          lineHeight: baseLineHeight * ratio + "px"
        }}
        fontSize={baseFontSize}
        imageId={this.state.data}
        viewport={this.state.viewport}
        imagePlane={this.state.imagePlane}
        rowCosines={rowCosines}
        columnCosines={columnCosines}
      />
    );
  };

  /**
   *
   *
   * @memberof Viewport
   */
  renderContextMenu = () => {
    var renderMenu = [];

    if (this.state.data !== undefined && this.state.data !== null) {
      renderMenu = [
        <MenuItem key={0} data={{}} onClick={this.handleRemoveData}>
          Unload it
        </MenuItem>,
        <MenuItem key={1} data={{ foo: "bar" }} divider={true} />,
        <MenuItem key={2} data={{}} onClick={this.handleClearAllView}>
          Unload all
        </MenuItem>
      ];
      return (
        <ContextMenu
          className={cx("noselect", "nodrag")}
          id={this.getContextMenuId()}
        >
          {renderMenu}
        </ContextMenu>
      );
    }

    return "";
  };

  /**
   *
   *
   * @memberof Viewport
   */
  renderToolContextMenu = () => {
    var renderMenu = [];

    if (this.state.data !== undefined && this.state.data !== null) {
      renderMenu = [
        <MenuItem key={0} data={{}} onClick={this.handleRemoveTool}>
          Remove
        </MenuItem>
      ];
      return (
        <ContextMenu
          id={this.getToolContextMenuId()}
          className={this.getToolContextMenuId()}
        >
          {renderMenu}
        </ContextMenu>
      );
    }

    return "";
  };

  renderViewport = () => {
    let className = "removable";
    let { identifier } = this.props;
    // console.log("this.props.sarcopeniaMeasureStore: ", this.props.sarcopeniaMeasureStore);
    const editmode = this.props.sarcopeniaMeasureStore.mode === 'edit';


    return (
      <React.Fragment>
        <div className={cx(className, "noselect", "nodrag")}>
        <div
          id={"viewer-" + identifier}
          tabIndex={identifier}
          className={cx(
            "imageViewerViewport",
            "viewport-element",
            this.getActiveClass(),
            editmode && "hide-cursor"
          )}
            onContextMenu={this.handleContextMenu}
            ref={input => {
              this.element = input;
            }}
        >
          <canvas className="viewer-canvas" />
        </div>
          {this.renderViewportOverlay()}
          {this.renderOverlaySlogan()}
          {this.renderOrientationMarkers()}
      </div>
      </React.Fragment>
    );
  };

  /**
   *
   *
   * @memberof Viewport
   */
  render = () => {
    let { hasContextMenu } = this.props;
    if (hasContextMenu) {
      return (
        <React.Fragment>
          <ContextMenuTrigger id={this.getContextMenuId()} holdToDisplay={-1}>
            {this.renderViewport()}
          </ContextMenuTrigger>
          {/* {this.renderContextMenu()}
          {this.renderToolContextMenu()} */}
        </React.Fragment>
      );
    } else {
      return <React.Fragment>{this.renderViewport()}</React.Fragment>;
    }
  };
}

export default Viewport;
